import PharmacyNav from "../../pages/Dashboard/Pharmacy/PharmacyNav";
import Pos from "../../pages/Dashboard/Pharmacy/POS/Pos";
import AddPrescription from "../../pages/Dashboard/Pharmacy/prescription/Prescription";
import AddMedicine from "../../pages/Dashboard/Pharmacy/medicine/addMedicine/AddMedicine";
import ListMedicine from "../../pages/Dashboard/Pharmacy/medicine/ListMedicine/ListMedicine";
import PharmacyIndex from "../../pages/Dashboard/Pharmacy/PharmacyIndex";
import PurchaseDrug from "../../pages/Dashboard/Pharmacy/PurchaseDrug/PurchaseDrug";
import MedicineStock from "../../pages/Dashboard/Pharmacy/stock/MedicineStock";
import MedicineExpirySexMonthLater from "../../pages/Dashboard/Pharmacy/MedicineExpirySexMonthLater/MedicineExpirySexMonthLater";
import LowQuantityStockMedicine from "../../pages/Dashboard/Pharmacy/LowQuantityStockMedicine/LowQuantityStockMedicine";
import AddReturnMedicine from "../../pages/Dashboard/Pharmacy/ReturnMedicine/addReturnMedicine/AddReturnMedicine";
import MedicineOrderList from "../../pages/Dashboard/Pharmacy/POS/PosList";
import PrescriptionList from "../../pages/Dashboard/Pharmacy/prescription/PrescriptionList";
import ListCompanyMedicine from "../../pages/Dashboard/Pharmacy/companyMedicine/ListCompanyMedicine/ListCompanyMedicine";
import AddCompanyMedicine from "../../pages/Dashboard/Pharmacy/companyMedicine/addCompanyMedicine/AddCompanyMedicine";
import PurchaseDrugList from "../../pages/Dashboard/Pharmacy/PurchaseDrug/PurchaseDrugList";
import ListReturnMedicine from "../../pages/Dashboard/Pharmacy/ReturnMedicine/addReturnMedicine/ListReturnMedicine";
import FreeMedicine from "../../pages/Dashboard/Pharmacy/FreeMedicine/FreeMedicine";
import FreeMedicineList from "../../pages/Dashboard/Pharmacy/FreeMedicine/FreeMedicineList";
import ListReturnMedicineToCompany from "../../pages/Dashboard/Pharmacy/ReturnMedicineToCompany/addReturnMedicine/ListReturnToCompany";
import AddReturnToCompany from "../../pages/Dashboard/Pharmacy/ReturnMedicineToCompany/addReturnMedicine/AddReturnToCompany";
import NewPatient from "../../pages/Dashboard/Pharmacy/NewPatient/NewPatient";
import PatientList from "../../pages/Dashboard/Pharmacy/PatientList/PatientList";
import MedicineCategory from "../../pages/Dashboard/Pharmacy/MedicineCategory/MedicineCategory";
import Scanner from "../../pages/Dashboard/Pharmacy/Scanner/Scanner";
import { Navigate } from "react-router-dom";

const pharmacyRoutes = {
  path: "/pharmacy",
  element: <PharmacyNav />,
  children: [
    { path: "/pharmacy", element: <PharmacyIndex /> },
    { path: "/pharmacy/scanner", element: <Scanner /> },
    { path: "/pharmacy/new-patient", element: <NewPatient /> },
    { path: "/pharmacy/patient-list", element: <PatientList /> },
    { path: "/pharmacy/pos", element: <MedicineOrderList /> },
    { path: "/pharmacy/pos/add", element: <Pos /> },

    { path: "/pharmacy/free-medicine", element: <FreeMedicineList /> },
    { path: "/pharmacy/free-medicine/add", element: <FreeMedicine /> },
    { path: "/pharmacy/prescription", element: <PrescriptionList /> },
    {
      path: "/pharmacy/collect-prescription-fees",
      element: <Navigate to="/finance/collect-prescription-fees" replace />,
    },
    {
      path: "/pharmacy/collect-medicine-order-fees",
      element: <Navigate to="/finance/collect-medicine-order-fees" replace />,
    },
    { path: "/pharmacy/prescription/add", element: <AddPrescription /> },
    { path: "/pharmacy/new-medicine", element: <AddMedicine /> },
    { path: "/pharmacy/medicine-list", element: <ListMedicine /> },
    { path: "/pharmacy/medicine-category", element: <MedicineCategory /> },
    { path: "/pharmacy/medicine-company", element: <ListCompanyMedicine /> },
    { path: "/pharmacy/medicine-company/add", element: <AddCompanyMedicine /> },
    { path: "/pharmacy/purchase-drug", element: <PurchaseDrugList /> },
    { path: "/pharmacy/purchase-drug/add", element: <PurchaseDrug /> },
    {
      path: "/pharmacy/return-medicine",
      element: <ListReturnMedicine />,
    },
    {
      path: "/pharmacy/return-medicine/add",
      element: <AddReturnMedicine />,
    },

    {
      path: "/pharmacy/return-to-company",
      element: <ListReturnMedicineToCompany />,
    },

    {
      path: "/pharmacy/return-to-company/add",
      element: <AddReturnToCompany />,
    },

    { path: "/pharmacy/medicine-stock", element: <MedicineStock /> },
    {
      path: "/pharmacy/medicine-expiry-six-months",
      element: <MedicineExpirySexMonthLater />,
    },
    {
      path: "/pharmacy/low-quantity-stock",
      element: <LowQuantityStockMedicine />,
    },
  ],
};

export default pharmacyRoutes;
